import { observer } from 'mobx-react-lite'
import { TeamsCreateProvider } from 'pages/settings/pages/teams/ui/TeamsCreate/context/teamsCreateContext'
import { TeamsCreate } from 'pages/settings/pages/teams/ui/TeamsCreate/ui/TeamsCreate'

export const TeamsCreateLayout = observer(() => (
  <TeamsCreateProvider>
    <TeamsCreate />
  </TeamsCreateProvider>
))
